// extracted by mini-css-extract-plugin
export default {"tag":"SelectFilterTag_tag__8PaHK"};